import React from 'react';
import styled from 'styled-components';

// Define styled components
const CardContainer = styled.div`
  background-color: ${(props) => props.color};
   color: #ECFFF7;
   border-Radius: 12px;
   top:8px;
   bottom:8px; 
   right:16px;
   left:16px;
   padding: 8px;
   cursor: pointer;
`;

const Title = styled.div`
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: #ECFFF7;
  padding: 4px;
`;

const Count = styled.div`
  font-weight: 700;
  font-size: 42px;
  line-height: 40px;
  color: #FFFFFF;
  height: 40px;
  padding: 8px;
`;

const Subtitle = styled.div`
  color: #FFFFFF;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  padding: 4px;
`;

const MarginLeftSpan = styled.div`
  margin-left: 8px;
  font-size: 0.8em;
`;

const DeviceCard = ({ title, count, subtitle, color }) => {
  return (
    <CardContainer color={color}>
      <Title>{title}</Title>
      <Count>{count}</Count>
      <MarginLeftSpan />
      <Subtitle>{subtitle}</Subtitle>
    </CardContainer>
  );
};

export default DeviceCard;
